import React, {useState, useEffect} from "react";
import { MainWrapper } from "../component/MainWrapper";
import { CleanerProfileCard } from "./component/CleanerProfileCard";
import { CleanerFilter } from "./component/CleanerFilter";
import { FormattedMessage } from "react-intl";
import ContentWithSpinner from "sr/layout/common/ContentWithSpiner";
import { useLocation, useParams } from "react-router-dom";
import { getJob } from "sr/utils/api/individual/job/getJob";
import { getAvailabilityCleaner } from "sr/utils/api/cleaner/getAvailabilityCleaner";
import ContentWithLoader from "sr/layout/common/ContentLoader";
import { JobLoaderCard } from "app/pages/jobs/component/JobLoaderCard";
export const CleanerProfiles = () => {
  const [data, setData] = useState([])
  const [loader, setLoader] = useState(true)
  const [jobId, setJobId] = useState('')
  const [jobData, setJobData] = useState(null)
  const [startTime, setStartTime] = useState<string>('')
  const [endTime, setEndTime] = useState<string>('')
  const params = useParams()
  const location = useLocation()
  const jobDraft = (location?.state as any)?.jobDraft
  const [minRange, setMinRange] = useState(1)
      const [maxRange, setMaxRange] = useState(1000)
  useEffect(()=> {
      const {jobid, from, to} = params
      setStartTime(from)
      setEndTime(to)
      setJobId(jobid)
  },[params])
  const fetchCleaner = async ()=> {
    setLoader(true)
    const queryParams = new URLSearchParams()
      const source = jobData || jobDraft
      if(!source) {
        setLoader(false)
        return
      }
      const scheduleDate = source?.schedule_date ? new Date(source?.schedule_date).toISOString() : undefined
      if(source?.title) queryParams.append('job_type', source?.title)
      if(scheduleDate) queryParams.append('schedule_date', scheduleDate)
      if(source?.lat) queryParams.append('lat', source?.lat)
      if(source?.lng) queryParams.append('lng', source?.lng)
      if(minRange) queryParams.append('min_rate', minRange?.toString())
      if(maxRange) queryParams.append('max_rate', maxRange?.toString())  
      if(startTime) queryParams.append('from', startTime)
      if(endTime) queryParams.append('to', endTime)

    try {
        const res = await getAvailabilityCleaner(queryParams)
        if(res?.success===true) {
          setData(res?.data)
            setLoader(false)
          }
        else {
          setLoader(false)
        }
    }
    catch(e:any) {
setLoader(false)
    }
   }
  
  useEffect(()=> {
    if((jobData || jobDraft)?.title) {
      fetchCleaner()
    }
  },[jobData?.title, jobDraft?.title, startTime, endTime, minRange, maxRange])
  const fetchJobData = async ()=> {
    const queryParams = new URLSearchParams()
    queryParams.append('id', jobId)
      try {
          const res = await getJob(queryParams)
          if(res?.success===true) {
            setJobData(res?.data)
          }
          else {
          }
      }
      catch(e) {
      }
  }
  useEffect(()=> {
if(jobId && jobId !== 'draft') {
fetchJobData()
} else if(jobDraft) {
  setJobData(jobDraft)
}
  },[jobId, jobDraft])
  const topHeader = (
    <div className="w-full">
        <div className="bg-white flex justify-center space-x-2 border border-neutral-200 py-3">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-6 h-6"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M19 7.5v3m0 0v3m0-3h3m-3 0h-3m-2.25-4.125a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zM4 19.235v-.11a6.375 6.375 0 0112.75 0v.109A12.318 12.318 0 0110.374 21c-2.331 0-4.512-.645-6.374-1.766z"
            />
          </svg>
          <FormattedMessage id="INDIVIDUAL.BOOKTASK.CLEANERLIST.DESCRIPTION" defaultMessage="Filter and sort to find your Cleaner. Then view their availability to request your date and time." />
        </div>
      </div>
  )
  return (
    <MainWrapper topHeader={topHeader}>
     
      <div className="py-3 lg:px-14 mx-auto">
        <div className="lg:grid lg:grid-cols-12 lg:gap-3">
     <CleanerFilter setMinRange={setMinRange} setMaxRange={setMaxRange} setStartTime={setStartTime} setEndTime={setEndTime}/>
       <ContentWithLoader loading={loader || data.length === 0} content={<JobLoaderCard></JobLoaderCard>}>
          <div className="col-span-8">
            {data.map((item)=> (
          <CleanerProfileCard item={item} jobData={jobData} jobDraft={jobDraft} />
          ))}
          </div>
          </ContentWithLoader>
        </div>
      </div>
      
    </MainWrapper>
  );
};
